// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".intro-modal[data-v-5577a4d5]{position:fixed;top:0;left:0;width:100%;height:100vh;background-color:rgba(0,0,0,.75);z-index:9999999}.intro-modal img[data-v-5577a4d5]{position:absolute;height:.22rem;right:.1rem;width:2.64rem;height:2.19rem}", ""]);
// Exports
module.exports = exports;
